"use client";

import React from "react";
import { useField } from "formik";
import FieldError from "../field-error/FieldError";
import "./Radio.css";

interface RadioProps {
  label: string;
  name: string;
  value: string | number;
  disabled?: boolean;
}

const Radio: React.FC<RadioProps> = ({ label, name, value, disabled = false }) => {
  const [field, meta] = useField({ name, type: "radio", value });

  const errorText = meta.touched && meta.error ? meta.error : undefined;
  const radioId = `${name}-${value}`;

  return (
    <div className={`radio-wrapper ${disabled ? "radio-disabled" : ""}`}>
      <label htmlFor={radioId} className="radio-label">
        <input
          id={radioId}
          type="radio"
          {...field}
          value={value}
          disabled={disabled}
          className="radio-input"
          aria-invalid={!!errorText}
          aria-describedby={errorText ? `${radioId}-error` : undefined}
        />
        <span className="radio-custom" />
        <span className="radio-label-text">{label}</span>
      </label>

      {errorText && (
        <div id={`${radioId}-error`}>
          <FieldError>{errorText}</FieldError>
        </div>
      )}
    </div>
  );
};

export default Radio;
